// Use relative URLs - the proxy in package.json will forward to localhost:5001
const API_BASE_URL = process.env.REACT_APP_HOST_API || '';
console.log('API_BASE_URL:', API_BASE_URL);

export const fetchUserKnowledgeGraph = async (userId , user) => {
  try {
    const accesstoken = user?.accesstoken;  
    const response = await fetch(`${API_BASE_URL}auth/user/knowledge-graph?userId=${userId}` ,{
      method: 'GET',
      headers:{
       'content-type':'application/json',
       'Authorization': `Bearer ${accesstoken}`,
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Handle both possible response structures: data.graphData or data.graph
    const graphData = data?.body?.graphData || data?.body?.graph || { nodes: [], links: [] };
    
    return {
      success: true,
      graphData: graphData,
      nodeCategories: data.nodeCategories || {},
      user: data.user || null,
      stats: data.stats || null,
    };
  } catch (error) {
    console.error('Error fetching user knowledge graph:', error);
    return {
      success: false,
      error: error.message,
      graphData: { nodes: [], links: [] },
      nodeCategories: {},
    };
  }
};

export const fetchRoomKnowledgeGraph = async (roomId , user) => {
  try {
    console.log('Fetching room knowledge graph for:', roomId);
    const accesstoken = user?.accesstoken;
    const response = await fetch(`${API_BASE_URL}room//knowledge-graph/${roomId}` ,{
      method: 'GET',
      headers:{
       'content-type':'application/json',
       'Authorization': `Bearer ${accesstoken}`,  
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Handle both possible response structures: data.graphData or data.graph
    const graphData = data?.body?.graphData || data?.body?.graph || { nodes: [], links: [] };
    
    return {
      success: true,
      graphData: graphData,
      nodeCategories: data.nodeCategories || {},
      room: data.room || null,
      stats: data.stats || null,
    };
  } catch (error) {
    console.error('Error fetching room knowledge graph:', error);
    return {
      success: false,
      error: error.message,
      graphData: { nodes: [], links: [] },
      nodeCategories: {},
    };
  }
};

// Default categories fallback
export const defaultNodeCategories = {
  user: { color: "#00f5ff", label: "You", icon: "👤" },
  skill: { color: "#b24cff", label: "Skills", icon: "⚡" },
  project: { color: "#ff3cac", label: "Projects", icon: "🚀" },
  interest: { color: "#00ff9d", label: "Interests", icon: "💡" },
  connection: { color: "#4d6cff", label: "Connections", icon: "🤝" },
  room: { color: "#4d6cff", label: "Room", icon: "🏠" },
};
